import { useEffect } from "react";

/**
 * Inject a JSON-LD <script type="application/ld+json"> tag into the document head.
 * Pass a stable `id` so the tag can be replaced/removed cleanly across renders.
 * Pass `null` data to skip injection.
 */
export function useJsonLd(id: string, data: object | null) {
  useEffect(() => {
    if (!data) return;
    const tagId = `jsonld-${id}`;
    let el = document.getElementById(tagId) as HTMLScriptElement | null;
    if (!el) {
      el = document.createElement("script");
      el.type = "application/ld+json";
      el.id = tagId;
      document.head.appendChild(el);
    }
    el.textContent = JSON.stringify(data);
    return () => {
      const existing = document.getElementById(tagId);
      if (existing) existing.remove();
    };
  }, [id, data]);
}
